import { css } from "styled-components";

export const PoppinsNormalWhite14px = css`
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxxxs);
  font-weight: 400;
  font-style: normal;
`;

export const RobotoBoldWhite18px = css`
  color: var(--white);
  font-family: var(--font-family-roboto);
  font-size: var(--font-size-xs);
  font-weight: 700;
  font-style: normal;
`;

export const Pressstart2pNormalAquamarineBlue15p = css`
  color: var(--aquamarine-blue);
  font-family: var(--font-family-press_start_2p);
  font-size: var(--font-size-xxxs);
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsBlackBlack16px = css`
  color: var(--black);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxs);
  font-weight: 900;
  font-style: normal;
`;

export const PoppinsNormalWhite12px = css`
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsNormalShadowBlue16px = css`
  color: var(--shadow-blue);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxs);
  font-weight: 400;
  font-style: normal;
`;

export const ArchivoNormalWhite17px = css`
  color: var(--white);
  font-family: var(--font-family-archivo);
  font-size: 17px;
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsSemiBoldVulcan15px = css`
  color: var(--vulcan);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxxs);
  font-weight: 600;
  font-style: normal;
`;

export const Pressstart2pNormalWhite34px = css`
  color: var(--white);
  font-family: var(--font-family-press_start_2p);
  font-size: var(--font-size-l);
  font-weight: 400;
  font-style: normal;
`;

export const ArchivoNormalWhite22px = css`
  color: var(--white);
  font-family: var(--font-family-archivo);
  font-size: var(--font-size-m);
`;

export const ArchivoBlackWhite22px = css`
  color: var(--white);
  font-family: var(--font-family-archivo);
  font-size: var(--font-size-m);
  font-weight: 900;
  font-style: normal;
`;

export const ArchivoNormalWhite22px2 = css`
  color: var(--white);
  font-family: var(--font-family-archivo);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const Pressstart2pNormalDenim13px = css`
  color: var(--denim);
  font-family: var(--font-family-press_start_2p);
  font-size: 13px;
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsSemiBoldVulcan28px = css`
  color: var(--vulcan);
  font-family: var(--font-family-poppins);
  font-size: 28px;
  font-weight: 600;
  font-style: normal;
`;

export const RobotoBlackWhite21px = css`
  color: var(--white);
  font-family: var(--font-family-roboto);
  font-size: 21px;
  font-weight: 900;
  font-style: normal;
`;

export const Pressstart2pNormalDenim34px = css`
  color: var(--denim);
  font-family: var(--font-family-press_start_2p);
  font-size: var(--font-size-l);
`;

export const Pressstart2pNormalDenim34px2 = css`
  color: var(--denim);
  font-family: var(--font-family-press_start_2p);
  font-size: var(--font-size-l);
  font-weight: 400;
  font-style: normal;
`;

export const ArchivoNormalBlack19px = css`
  color: var(--black);
  font-family: var(--font-family-archivo);
  font-size: var(--font-size-s);
  font-weight: 400;
  font-style: normal;
`;

export const ArchivoBlackAquamarineBlue24px = css`
  color: var(--aquamarine-blue);
  font-family: var(--font-family-archivo);
  font-size: 24px;
  font-weight: 900;
  font-style: normal;
`;

export const RobotoBoldBlack17px = css`
  color: var(--black);
  font-family: var(--font-family-roboto);
  font-size: 17px;
  font-weight: 700;
  font-style: normal;
`;

export const PoppinsSemiBoldTorchRed16px = css`
  color: var(--torch-red);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxs);
  font-weight: 600;
  font-style: normal;
`;

export const PoppinsNormalShadowBlue12px = css`
  color: var(--shadow-blue);
  font-family: var(--font-family-poppins);
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
`;

export const PoppinsBlackBlack14px = css`
  color: var(--black);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-xxxxs);
  font-weight: 900;
  font-style: normal;
`;

export const PoppinsNormalWhite13px = css`
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: 13px;
  font-weight: 400;
  font-style: normal;
`;

export const Border1pxMountainMist = css`
  border: 1px solid var(--mountain-mist);
`;

export const Border1pxWhite = css`
  border: 1px solid var(--white);
`;

export const Border2pxBlack = css`
  border: 2px solid var(--black);
`;
